import React, { Suspense, useEffect, useMemo, useState } from "react";

// ANCHOR compoentns
import Routes from "./routes";
import { SystemProvider } from "./context/systemContext";
import { useHistory, useLocation } from "react-router";
import { api } from "./services/api/api";
import { BaseResponse } from "./services/api/response/BaseResponse";
import browserStorage from "./services/storage";
import get from "lodash.get";
import { NOTIFICATIONS_LIST_LIMIT } from "./modules/navigator/notification/container/Notifications.contants";
//@ts-ignore
import AudioData from "./assets/audio/notification.mp3";
import FirebaseApp from "./FirebaseApp";
import { ThemeProvider } from "styled-components";
import { LightTheme } from "./styles/theme/lightTheme";
import { DarkTheme } from "./styles/theme/darkTheme";
import { Link } from "react-router-dom";
import SubExpiredModal from "./components/SubExpiredModal/SubExpiredModal";
import { currentCurrency } from "./constants/currentCurrency";

const App: React.FC<{}> = () => {
  const token = browserStorage.get<null | string>("token");
  const defaultThemeState: string | null | undefined = browserStorage.get(
    "themeState"
  );
  const location = useLocation();
  const branchList: any = browserStorage.get("branchList");
  const role: any = browserStorage.get("role");
  const history = useHistory();
  const [themeState, setThemeState] = useState<string>(
    defaultThemeState || "light"
  );
  const [showExp, setShowExp] = useState<boolean>(false);
  const isFrozen: string | undefined = browserStorage.get("isFrozen");

  useEffect(() => {
    if (isFrozen) {
      setShowExp(true);
    } else {
      setShowExp(false);
    }
  }, [isFrozen]);

  const publicPath = [
    "/",
    "/password",
    "/sign-with-password",
    "/sign-verify",
    "/forget-password",
  ];

  useEffect(() => {
    if (history.location.pathname === "/" && token) {
      history.push("/home");
    }
  }, [history.location]);

  const notificationPlay = () => {
    const audio = new Audio(AudioData);
    audio.play();
    // audio.remove()
  };

  const getNotifications = async (page: number = 1) => {
    try {
      const response = await api.apiCall<BaseResponse<any>>(
        "/notification-pagin",
        { page: page, limit: NOTIFICATIONS_LIST_LIMIT },
        "post"
      );
      if (response.data) {
        setSystemState((prev: any) => {
          return {
            ...prev,
            notificationLength: get(response, "data.data.total", 0),
          };
        });
      }
      return {
        notificationList: get(response, "data.data.data", []),
        notificationListTotal: get(response, "data.data.total", 0),
      };
    } catch (error: any) {
      if (get(error, "response.data.code", 0) === 401) {
        localStorage.clear();
        history.push("/");
      }
    }
  };

  const getBranches = async () => {
    try {
      const { data } = await api.apiCall<BaseResponse<any>>(
        "/branches",
        null,
        "get"
      );
      setSystemState((prev: any) => {
        return {
          ...prev,
          loader: false,
          branchList: data?.data,
        };
      });
      if (!browserStorage.get("branchList")) {
        browserStorage.set("branchList", data?.data);
      }

      if (!browserStorage.get("branch")) {
        browserStorage.set("branch", data?.data[0]?._id);
      }

      browserStorage.set("branchList", data?.data);
    } catch (e: any) {
      if (get(e, "response.data.code", 0) === 401) {
        localStorage.clear();
        history.push("/");
      }
    }
  };

  const getStatus = async () => {
    try {
      const response = await api.apiCall<BaseResponse<any>>(
        "/statuses",
        {},
        "get"
      );
      if (response.data) {
        setSystemState((prev: any) => {
          return {
            ...prev,
            statusList: get(response, "data.data", []),
          };
        });
      }
    } catch (e: any) {
      if (get(e, "response.data.code", 0) === 401) {
        localStorage.clear();
        history.push("/");
      }
    }
  };

  const getRole = async () => {
    try {
      const res = await api.apiCall<BaseResponse<any>>("/role", {}, "get");
      setSystemState((prev: any) => ({
        ...prev,
        roles: get(res, "data.data", {}),
      }));
      browserStorage.set("role", res.data?.data);
    } catch (e: any) {
      if (get(e, "response.data.code", 0) === 401) {
        localStorage.clear();
        history.push("/");
      }
    }
  };

  const getLicense = async () => {
    try {
      const res = await api.apiCall<BaseResponse<any>>(
        "/billing/state",
        {},
        "get"
      );
      setSystemState((prev: any) => ({
        ...prev,
        currentBilling: get(res, "data.data", {}),
      }));
    } catch (e: any) {
      if (get(e, "response.data.code", 0) === 401) {
        localStorage.clear();
        history.push("/");
      }
    }
  };

  const getProfile = async () => {
    try {
      const response = await api.apiCall<BaseResponse<string>>(
        "/profile",
        {},
        "get"
      );
      if (response.data) {
        browserStorage.set("user", get(response, "data.data", {}));
        setSystemState((prev: any) => {
          return {
            ...prev,
            profile: get(response, "data.data", {}),
          };
        });
      }
    } catch (e: any) {
      if (get(e, "response.data.code", 0) === 401) {
        localStorage.clear();
        history.push("/");
      }
    }
  };

  const getNotificationSettings = async () => {
    try {
      const res = await api.apiCall<BaseResponse<any>>(
        "/notification-settings",
        {},
        "get"
      );
      if (res?.data) {
        setSystemState((prev: any) => {
          return {
            ...prev,
            notification: get(res, "data.data", {}),
          };
        });
      }
    } catch (e: any) {
      if (get(e, "response.data.code", 0) === 401) {
        localStorage.clear();
        history.push("/");
      }
    }
  };

  const getOrgSettings = async () => {
    try {
      const res = await api.apiCall<BaseResponse<any>>(
        "/org-settings",
        {},
        "get"
      );
      if (res?.data) {
        browserStorage.set("orgSettings", res.data?.data);
        setSystemState((prev: any) => {
          return {
            ...prev,
            orgSettings: get(res, "data.data", {}),
          };
        });
      }
    } catch (e: any) {
      if (get(e, "response.data.code", 0) === 401) {
        localStorage.clear();
        history.push("/");
      }
    }
  };

  // const getOrganizationCheck = async () => {
  //   try {
  //       const headers: any = {};
  //       if (process.env.NODE_ENV === "development") {
  //         headers["username"] = process.env.REACT_APP_DOMEN;
  //       }
  //     const res = await api.apiCall<BaseResponse<any>>(
  //       "/organization-check",
  //       headers,
  //       "post"
  //     );
  //     if (res?.data) {
  //       browserStorage.set("organizationCheck", res.data?.data);
  //       setSystemState((prev: any) => {
  //         return {
  //           ...prev,
  //           organizationCheck: get(res, "data.data", {}),
  //         };
  //       });
  //     }
  //   } catch (e: any) {
  //     if (get(e, "response.data.code", 0) === 401) {
  //       localStorage.clear();
  //       history.push("/");
  //     }
  //   }
  // };

  //test
  const [systemState, setSystemState] = useState<any>({
    loader: true,
    branchList: [],
    branch: null,
    roles: undefined,
    statusList: [],
    getBranches: getBranches,
    getRole: getRole,
    getProfile: getProfile,
    getNotifications,
    notificationPlay,
    setThemeState,
    getNotificationSettings,
    getOrgSettings,
    // getOrganizationCheck,
    themeState,
    notification: {},
    orgSettings: browserStorage.getParse("orgSettings")
      ? browserStorage.getParse("orgSettings")
      : {},
    // organizationCheck:browserStorage.getParse("organizationCheck")
    //   ? browserStorage.getParse("organizationCheck")
    //   : {},
  });


  const getAll = async () => {
    setSystemState((prev: any) => {
      return {
        ...prev,
        branchList: branchList ? JSON.parse(branchList) : [],
        roles: role ? JSON.parse(role) : undefined,
        // branch: {_id: "id", name: "salom"},
      };
    });

    // await getOrganizationCheck();
    await getOrgSettings();
    await getBranches();
    await getStatus();
    await getRole();
    await getProfile();
    await getNotificationSettings();
    await getLicense();

    setSystemState((prev: any) => ({
      ...prev,
      loader: false,
    }));
  };

  useEffect(() => {
    if (systemState.roles === undefined) {
      if (browserStorage.get("token")) {
        if (!publicPath.includes(location.pathname)) {
          getAll();
        }
      }
    } else {
      if (
        location.pathname === "/" ||
        // location.pathname === "/home" ||
        location.pathname === "/sign-with-password"
      ) {
        setSystemState((prev: any) => ({
          ...prev,
          roles: undefined,
        }));
      }
    }
  }, [location]);

  const theme = useMemo(() => {
    setSystemState((prev: any) => {
      return {
        ...prev,
        themeState,
      };
    });
    if (themeState === "dark") return DarkTheme;
    else return LightTheme;
  }, [themeState]);

  useEffect(() => {
    window.addEventListener("storage", (e) => {
      const updatedOrgSettings = browserStorage.getParse("orgSettings");
      if (updatedOrgSettings) {
        setSystemState((prev: any) => {
          return {
            ...prev,
            orgSettings: updatedOrgSettings,
          };
        });
      }
    });
  }, []);

  return (
    <Suspense fallback={""}>
      <ThemeProvider theme={theme}>
        <SystemProvider value={systemState}>
          {showExp && <SubExpiredModal />}
          <FirebaseApp />
          <Routes />
        </SystemProvider>
      </ThemeProvider>
    </Suspense>
  );
};

export default App;
